<template>
    <div class="border-top">
        <SOFilterTitle :title="getTitle" :diterapkan="diterapkan" :id="id" />
        <div class="p-l-24 p-r-24 p-d-24" style="display: none" :id="id">
            <SOFilterCheckboxSkeleton v-if="pageSetting.loading" />
            <SOInputCheckbox
                :checkboxes="checkboxProvider"
                :checked="filterItem.providerEdc"
                :limit-loop="true"
                :limit-loop-count="4"
                :use-check-all="useCheckAll"
                :modal-id="`${id}-more`"
                :modal-title="getTitle"
                @selected="selected"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOFilterCheckboxSkeleton from "@/so-components/global/filter/skeleton/SOFilterCheckboxSkeleton";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
    name: "SOFilterProviderEdc",
    components: {
        SOFilterTitle,
        SOFilterCheckboxSkeleton,
        SOInputCheckbox,
    },
    props: {
        id: String,
        title: String,
        useCheckAll: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        ...mapGetters("mesinEdcModule", {
            providerEdcs: "listProvider",
        }),
        getTitle() {
            return this.title ? this.title : "Provider";
        },
    },
    data() {
        return {
            checkboxProvider: {
                name: "providerEdc",
                data: [],
            },
            pageSetting: {
                loading: true,
            },
            diterapkan: false,
        };
    },
    watch: {
        providerEdcs: function(newProvider, oldProvider) {
            if (newProvider.length > 0) {
                this.setDataProvider(newProvider);
            }
        },
    },
    mounted() {
        this.getProviderEdc();
        this.diterapkan = this.filterItem.providerEdc.length > 0;
    },
    methods: {
        ...mapActions({
            getListProvider: "mesinEdcModule/getListProvider",
        }),
        async getProviderEdc() {
            this.pageSetting.loading = true;
            this.getListProvider(false);
        },
        setDataProvider(provider) {
            this.pageSetting.loading = false;
            this.checkboxProvider.data = [];
            provider.forEach((item) => {
                this.checkboxProvider.data.push({
                    id: `f-provider-${item.id}`,
                    value: item.id,
                    title: item.text,
                    checked: false,
                    titleBold: false,
                    // disabled: item.hapus === 1
                });
            });
        },
        selected(val) {
            let selected = [];
            if (typeof val === "string") {
                if (val === "checkAll") {
                    this.providerEdcs.forEach((item) => {
                        selected.push(item.id);
                    });
                } else {
                    selected = [];
                }
            } else {
                selected = val;
            }

            let temp = this.filterItem;
            temp.providerEdc = selected;
            this.$store.commit("filterGlobalModule/setFilterItem", temp);
            this.diterapkan = this.filterItem.providerEdc.length > 0;
        },
    },
};
</script>
